import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Header2 } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { getUserById } from "../../../../../../store/selectors/selector.users.jsx";
import { useWhoIsOnlineContext } from "../../../../../WhoIsOnline/index.jsx";
import { HeaderNameMenu } from "../../HeaderNameMenu.jsx";

export const BaseOneToOneConversation = ({ id, showHeaderMenu }) => {
  const { members: onlineMembers } = useWhoIsOnlineContext();
  const { t } = useTranslation();

  const user = useSelector((state) => getUserById(state, id));

  const isOnline = useMemo(() => !!onlineMembers?.some((userId) => userId === id), [id, onlineMembers]);

  const name = user?.display_name || t("Archived Conversation");

  return (
    <div className="tw-flex tw-items-center tw-min-w-0">
      {showHeaderMenu ? (
        <HeaderNameMenu
          name={name}
          statusClassName={classnames({
            online: isOnline,
            offline: !isOnline,
          })}
          showStatus={!!user}
        />
      ) : (
        <div className="tw-min-w-0 tw-py-6 tw-px-1 tw-inline-flex tw-items-center">
          <div
            className={classnames("header-user-status tw-w-3 tw-h-3 tw-border-full tw-mr-2 tw-shrink-0", {
              online: isOnline,
              offline: !isOnline,
            })}
          />
          <Header2
            weight="bold"
            color="primary"
            className="tw-truncate"
          >
            {name}
          </Header2>
        </div>
      )}
    </div>
  );
};

BaseOneToOneConversation.propTypes = {
  id: PropTypes.number,
  showHeaderMenu: PropTypes.bool,
};

BaseOneToOneConversation.defaultProps = {
  id: 0,
  showHeaderMenu: false,
};
